import React from 'react';
import { Shield, Scale, ScrollText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Terms = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-obsidian text-cream-100 p-6 pt-20">
            <div className="max-w-3xl mx-auto space-y-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-cream-200/60 hover:text-cream-50 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <header className="space-y-4">
                    <div className="w-12 h-12 rounded-xl bg-copper-500/20 flex items-center justify-center">
                        <Scale className="w-6 h-6 text-copper-400" />
                    </div>
                    <h1 className="text-4xl font-display font-bold text-cream-50">Terms of Service</h1>
                    <p className="text-cream-200/60 text-lg">Last updated: February 16, 2026</p>
                </header>

                <div className="space-y-8 text-cream-200/80 leading-relaxed">
                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">1. Agreement to Terms</h2>
                        <p>
                            By accessing and using CardBoss ("the Platform"), you agree to be bound by these Terms of Service.
                            If you do not agree to these terms, please do not use our services.
                        </p>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">2. Marketplace & Escrow</h2>
                        <p>
                            CardBoss operates a peer-to-peer marketplace for trading cards. To ensure safety:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>All payments are held in <strong>Escrow</strong> until the buyer confirms receipt of the item.</li>
                            <li>Sellers must provide valid tracking numbers for all shipments.</li>
                            <li>Funds are released to the seller 48 hours after delivery is confirmed, unless a dispute is raised.</li>
                        </ul>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">3. User Responsibilities</h2>
                        <p>
                            You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account.
                            You agree to provide accurate information when listing items and to ship sold items within 3 business days.
                        </p>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">4. Prohibited Items</h2>
                        <p>
                            Counterfeit, altered, or misleadingly described cards are strictly prohibited.
                            We reserve the right to ban users who attempt to sell inauthentic items.
                        </p>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">5. Fees</h2>
                        <p>
                            CardBoss charges a 5% transaction fee on all completed sales. This fee covers payment processing and platform maintenance.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};
